import React from 'react'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    ArcElement,
    Tooltip,
    Legend
} from "chart.js";
import { Chart } from "react-chartjs-2";
import { Doughnut } from "react-chartjs-2";
import { Pie } from "react-chartjs-2";
import { FaMicrophone } from "react-icons/fa";
import RingProgress from './RingProgress';

import { LuMessageCircleMore } from "react-icons/lu";
import { FaPhoneVolume } from "react-icons/fa6";
import { FaShieldAlt } from "react-icons/fa";
import { FaUser } from "react-icons/fa";
import { FaExclamationTriangle } from "react-icons/fa";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    ArcElement,
    Tooltip,
    Legend
);


function DailyConsumption() {

    const data = [
        {
            title: "Voice Count",
            icon: <FaMicrophone />,
            color: '#3f7fca',
            count: {
                answered: 320,
                notAnswered: 180,
                total: 500
            },
            percentage: 64
        },
        {
            title: "SMS Count",
            count: {
                delivered: 850,
                pending: 120,
                failed: 30
            },
            percentage: 85
        },
        {
            title: "WhatsApp Count",
            count: {
                delivered: 670,
                pending: 90,
                failed: 40
            },
            percentage: 80
        },
        {
            title: "RCS Count",
            count: {
                delivered: 540,
                pending: 110,
                failed: 50
            },
            percentage: 75
        }
    ];
    const statsData = [
        {
            title: "Total Chats",
            value: 0,
            icon: <LuMessageCircleMore />,
            color: '#23a2cd'
        },
        {
            title: "Total Calls",
            value: 0,
            icon: <FaPhoneVolume />,
            color: '#28b463'
        },
        {
            title: "Unassigned",
            value: 0,
            icon: <FaShieldAlt />,
            color: '#5499c7'
        },
        {
            title: "Chats per Agent",
            value: 0,
            icon: <FaUser />,
            color: '#e67e22'
        },
        {
            title: "High Priority",
            value: 0,
            icon: <FaExclamationTriangle />,
            color: '#ec7063'
        }
    ];
    const AverageTime = [
        {
            title: "Total Chats",
            value: `00:00:00`,
            icon: <LuMessageCircleMore />,
            color: '#23a2cd'
        },
        {
            title: "Total Calls",
            value: `00:00:00`,
            icon: <FaPhoneVolume />,
            color: '#28b463'
        }
    ];

    const dataLinebar = {
        labels: ["2025-05-27", "2025-05-28", "2025-05-29", "2025-05-30", "2025-05-31", "2025-06-01", "2025-06-02"],
        datasets: [

            {
                type: "line",
                label: "Incoming",
                data: [1, 3, 5, 2, 1, 4, 5],
                borderColor: "#f59e0b",
                borderWidth: 2,
                fill: false,
                tension: 0.4,
            },
            {
                type: "line",
                label: "Resolved",
                data: [3, 2, 1, 5, 4, 1, 3, 4],
                borderColor: "#4f46e5",
                borderWidth: 2,
                fill: false,
                tension: 0.4,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: "top",
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    stepSize: 2, // 👉 this gives 0,2,4,6
                },
                grid: {
                    drawBorder: false,
                },
            },
            x: {
                grid: {
                    display: false, // optional clean UI
                },
            },
        },
    };

    const pieData = {
        labels: ["Chats", "Calls", "whatsapp", "Email"],
        datasets: [
            {
                data: [20, 30, 15, 35], // 👉 values (auto % divide)
                backgroundColor: [
                    "#FFA02E",
                    "#FF3737",
                    "#6FCF97",
                    '#7DAACB'
                ],
                borderWidth: 0, // clean look
            },
        ],
    };

    const pieOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            tooltip: {
                callbacks: {
                    label: function (context) {
                        const total = context.dataset.data.reduce((a, b) => a + b, 0);
                        const value = context.raw;
                        const percent = ((value / total) * 100).toFixed(0);
                        return `${context.label}: ${percent}%`;
                    },
                },
            },
        }
    }


    const doughnutData = {
        datasets: [
            {
                data: [10, 30], // 👉 percentage split
                backgroundColor: ["#4f46e5", "#e5e7eb"],
                borderWidth: 0,
                cutout: "80%", // 🔥 makes it ring (circle type)
            },
        ],
    };

    const doughnutOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            tooltip: {
                enabled: false, // optional
            },
            legend: {
                display: false,
            },
        },
    };

    const percentage = doughnutData.datasets[0].data[0];

    return (
        <>
            <div className='w-[100%] dark:bg-[#121519] pt-[70px] px-4'>
                <div className='w-[100%] p-2 flex justify-end  pr-6'>
                    <button className='bg-[#316bb0] flex text-[#fff] items-center text-[12px] font-semibold p-2 rounded-lg gap-1'> Quick Links</button>
                </div>
                <div className='w-[100%] flex flex-wrap justify-between items-center gap-4'>
                    {data.length > 0 &&
                        data.map((item, index) => (
                            <div className='w-[100%] md:w-[24%] sm:w-[48%] p-[18px] shadow-[0px_5px_15px_rgba(0,0,0,0.35)] rounded-[10px]'>
                                <div className='w-[100%] flex justify-between items-center'>
                                    <h5 className='text-[#576071] font-semibold text-[14px]'>{item.title}</h5>
                                    <i className='text-[20px]' style={{ color: item.color }}>{item.icon}</i>
                                </div>
                                <div className='w-[100%] flex items-center justify-between mt-3'>
                                    <div>
                                        <p className='text-[#576071] font-semibold text-[11px]'> {item.count.answered ? 'Answered ' : 'Delivered '} <span className='text-[#3f7fca]'>{item.count.answered || item.count.delivered}</span> </p>
                                        <p className='text-[#576071] font-semibold text-[11px]'> {item.count.notAnswered ? 'Not Answered ' : 'Pending '} <span className='text-[#3f7fca]'>{item.count.notAnswered || item.count.pending}</span> </p>
                                        <p className='text-[#576071] font-semibold text-[11px]'> {item.count.total ? 'Total ' : 'Failed '} <span className='text-[#3f7fca]'>{item.count.total || item.count.failed}</span> </p>
                                    </div>
                                    <div>
                                        <RingProgress percentage={item.percentage} />
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
                <div className='w-[100%] flex flex-wrap items-center justify-between gap-4 mt-4'>
                    <div className='w-[100%] m sm:w-[70%] p-[18px] shadow-[0px_5px_15px_rgba(0,0,0,0.35)] rounded-[10px]'>
                        <h5 className='text-[#576071] font-semibold text-[14px]'>Chats & Call Status</h5>
                        <div className='w-[100%] flex flex-wrap justify-between items-center mt-4 gap-3 '>
                            {statsData.map((item, index) => (
                                <div className='flex items-center gap-2'>
                                    <div style={{ backgroundColor: item.color }} className='p-2 rounded-md'>
                                        <i className='text-[#fff]'>{item.icon}</i>
                                    </div>
                                    <div>
                                        <p className='text-[#576071] font-semibold text-[14px]'>{item.value}</p>
                                        <p className='text-[#576071]  text-[14px]'>{item.title}</p>
                                    </div>
                                </div>
                            ))
                            }
                        </div>
                    </div>
                    <div className='w-[100%] m sm:w-[28%] p-[18px] shadow-[0px_5px_15px_rgba(0,0,0,0.35)] rounded-[10px]'>
                        <h5 className='text-[#576071] font-semibold text-[14px]'>Average Time</h5>
                        <div className='w-[100%] flex flex-wrap justify-between items-center mt-4 gap-3 '>
                            {AverageTime.map((item, index) => (
                                <div className='flex items-center gap-2'>
                                    <div style={{ backgroundColor: item.color }} className='p-2 rounded-md'>
                                        <i className='text-[#fff]'>{item.icon}</i>
                                    </div>
                                    <div>
                                        <p className='text-[#576071]  text-[14px]'>{item.title}</p>
                                        <p className='text-[#576071] font-semibold text-[14px]'>{item.value}</p>
                                    </div>
                                </div>
                            ))
                            }
                        </div>
                    </div>
                </div>
                <div className='w-[100%] flex flex-wrap items-center justify-between gap-4 mt-4 '>
                    <div className='w-[100%] sm:w-[70%] p-[18px] shadow-[0px_5px_15px_rgba(0,0,0,0.35)] rounded-[10px] h-[350px]'>
                        <h5 className='text-[#576071] font-semibold text-[14px]'>Incoming vs Resolved</h5>
                        <div className='w-[100%] h-[calc(100%-30px)]'>
                            <Chart type="line" data={dataLinebar} options={options} />
                        </div>
                    </div>
                    <div className='w-[100%] m sm:w-[28%] p-[18px] shadow-[0px_5px_15px_rgba(0,0,0,0.35)] rounded-[10px] h-[350px]'>

                    </div>
                </div>
                <div className='w-[100%] flex flex-wrap items-center justify-between gap-4 mt-4 '>
                    <div className='w-[100%] sm:w-[70%] p-[18px] shadow-[0px_5px_15px_rgba(0,0,0,0.35)] rounded-[10px] h-[350px]'>
                        <h5 className='text-[#576071] font-semibold text-[14px]'>Hourly Status</h5>
                        <div className='w-[100%] h-[calc(100%-30px)]'>
                            <Chart type="line" data={dataLinebar} options={options} />
                        </div>
                    </div>
                    <div className='w-[100%] m sm:w-[28%] p-[18px] shadow-[0px_5px_15px_rgba(0,0,0,0.35)] rounded-[10px] h-[350px]'>
                        <Pie data={pieData} options={pieOptions} />
                    </div>
                </div>
                <div className='w-[100%] flex flex-wrap items-center justify-between gap-4 mt-4 '>
                    <div className='w-[100%] sm:w-[70%] p-[18px] shadow-[0px_5px_15px_rgba(0,0,0,0.35)] rounded-[10px] h-[350px]'>
                        <h5 className='text-[#576071] font-semibold text-[14px]'>Last 7 Days</h5>
                        <div className='w-[100%] h-[calc(100%-30px)]'>
                            <Chart type="line" data={dataLinebar} options={options} />
                        </div>
                    </div>
                    <div className='w-[100%] m sm:w-[28%] p-[18px] shadow-[0px_5px_15px_rgba(0,0,0,0.35)] rounded-[10px] h-[350px]'>
                        <h5 className='text-[#576071] font-semibold text-[14px]'>CSAT</h5>

                        <div className="relative w-[50px] h-[50px]">
                            <Doughnut data={doughnutData} options={doughnutOptions} />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <span className="text-[20px] font-bold text-[#4f46e5]">
                                    {percentage}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DailyConsumption


